import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import AppIcons from '../../assets/images/icons';
import './trustedPartnersPopup.scss';



function TrustedPartnersPopup() {
  const [open, setOpen] = React.useState(false);
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className='partners-popup-box'>
      <Button className='partners-btn' variant="outlined" onClick={handleClickOpen}>
        Partners
      </Button>

      <Dialog id="popup-modal-revamp" open={open} onClose={handleClose}>
        <DialogContent className='partners-popup-modal'>
          <DialogActions className='float-btn'>
            <span onClick={handleClose}><svg width="25" height="25" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.53341 25.8334L6.66675 23.9667L14.1334 16.5001L6.66675 9.03341L8.53341 7.16675L16.0001 14.6334L23.4667 7.16675L25.3334 9.03341L17.8667 16.5001L25.3334 23.9667L23.4667 25.8334L16.0001 18.3667L8.53341 25.8334Z" fill="#FFFFFF" />
            </svg>
            </span>
          </DialogActions>
          <div className='popup-content-box f-wrp'>
            <div className='title-box f-wrp'>
              <h1>Trusted Partners</h1>
              <p>We partner with top-tier names in the UAE to offer you exclusive opportunities, early access, and a seamless investment experience.</p>
            </div>
            <div className='each-partner-wrp f-wrp'>
              <h1>Banks</h1>
              <div className='each-partner-box f-wrp'>
                <ul>
                  <li><span><img src={AppIcons.part1} alt='partner' /></span>
                    <p>Emirates NBD</p></li>
                  <li><span><img src={AppIcons.part2} alt='partner' /></span>
                    <p>Dubai Islamic Bank</p></li>
                  <li><span><img src={AppIcons.part3} alt='partner' /></span>
                    <p>ADCB</p></li>
                  <li><span><img src={AppIcons.part4} alt='partner' /></span>
                    <p>First Abu Dhabi Bank</p></li>
                  <li><span><img src={AppIcons.part5} alt='partner' /></span>
                    <p>Mashreq</p></li>
                  <li><span><img src={AppIcons.part6} alt='partner' /></span>
                    <p>RAKBANK</p></li>
                  <li><span><img src={AppIcons.part7} alt='partner' /></span>
                    <p>ADIB</p></li>
                  <li><span><img src={AppIcons.part8} alt='partner' /></span>
                    <p>HSBC ME</p></li>
                  <li><span><img src={AppIcons.part9} alt='partner' /></span>
                    <p>Standard Chartered</p></li>
                  <li><span><img src={AppIcons.part10} alt='partner' /></span>
                    <p>CBD</p></li>
                </ul>
              </div>
            </div>
            <div className='each-partner-wrp f-wrp'>
              <h1>Companies</h1>
              <div className='each-partner-box f-wrp'>
                <ul>
                  <li><span><img src={AppIcons.part11} alt='partner' /></span>
                    <p>VTEN</p></li>
                  <li><span><img src={AppIcons.part12} alt='partner' /></span>
                    <p>World Development
                    Programme</p></li>

                </ul>
              </div>
            </div>
          </div>

        </DialogContent>

      </Dialog>
    </div>
  );
}

TrustedPartnersPopup.propTypes = {}
export default TrustedPartnersPopup
